import Swiper from "swiper/bundle";

let swiper_successful_cases = new Swiper(".swiper-successful-cases", {
  loop: true,
  autoplay: {
    delay: 1500,
    disableOnInteraction: false,
  },
  speed: 1200,
  slidesPerView: 4,
  spaceBetween: 6,
});
